<template>
  <van-overlay :show="true" :custom-style="{
    background: 'rgba(0, 0, 0, 0.8)'
  }" @click="handleClose" z-index="9999">
    <div class="download-mask relative">
      <img class="w-250 h-130 absolute top-0 right-0" src="https://cdn.docoi.cc/static/h5_assets/download-mask.webp" />
    </div>
  </van-overlay>
</template>

<script setup lang="ts">
interface Props {
  canHiden?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  canHiden: true
});

const emit = defineEmits<{
  close: [];
}>();

const handleClose = () => {
  if (!props.canHiden) return;
  emit('close');
};
</script>

<style lang="scss" scoped>
.download-mask {
  width: 100vw;
  height: 100vh;
}

</style>
